module.exports = __webpack_public_path__ + "static/media/cert_99-tc.1f274c65.jpg";